/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface ScoutActionActionArgs {
  noArgs: boolean;
}

export interface ScoutActionResultData {
}

export interface ScoutActionActionStateData {
}

function createBaseScoutActionActionArgs(): ScoutActionActionArgs {
  return { noArgs: false };
}

export const ScoutActionActionArgs = {
  encode(message: ScoutActionActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.noArgs === true) {
      writer.uint32(8).bool(message.noArgs);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScoutActionActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScoutActionActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.noArgs = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScoutActionActionArgs {
    return { noArgs: isSet(object.noArgs) ? globalThis.Boolean(object.noArgs) : false };
  },

  toJSON(message: ScoutActionActionArgs): unknown {
    const obj: any = {};
    if (message.noArgs === true) {
      obj.noArgs = message.noArgs;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScoutActionActionArgs>, I>>(base?: I): ScoutActionActionArgs {
    return ScoutActionActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScoutActionActionArgs>, I>>(object: I): ScoutActionActionArgs {
    const message = createBaseScoutActionActionArgs();
    message.noArgs = object.noArgs ?? false;
    return message;
  },
};

function createBaseScoutActionResultData(): ScoutActionResultData {
  return {};
}

export const ScoutActionResultData = {
  encode(_: ScoutActionResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScoutActionResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScoutActionResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ScoutActionResultData {
    return {};
  },

  toJSON(_: ScoutActionResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ScoutActionResultData>, I>>(base?: I): ScoutActionResultData {
    return ScoutActionResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScoutActionResultData>, I>>(_: I): ScoutActionResultData {
    const message = createBaseScoutActionResultData();
    return message;
  },
};

function createBaseScoutActionActionStateData(): ScoutActionActionStateData {
  return {};
}

export const ScoutActionActionStateData = {
  encode(_: ScoutActionActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScoutActionActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScoutActionActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ScoutActionActionStateData {
    return {};
  },

  toJSON(_: ScoutActionActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ScoutActionActionStateData>, I>>(base?: I): ScoutActionActionStateData {
    return ScoutActionActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScoutActionActionStateData>, I>>(_: I): ScoutActionActionStateData {
    const message = createBaseScoutActionActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
